var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.titles[_vm.type]))])
}
var staticRenderFns = []

export { render, staticRenderFns }